import fromPairs from 'lodash/fromPairs'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import moment from 'moment'
import uuid from 'uuid'
import * as Types from './types'

export const isSelectedPartner = (partner: string, selected: string): boolean => {
  return isEmpty(selected) ? isEmpty(partner) : selected === partner
}

export const findConfig =
  (key: string, partnerCode: string, configs: Types.ConfigurationRow[]): Types.ConfigurationRow => {
  const keyConfigs = configs.filter((r: Types.ConfigurationRow) => r.data.key === key)
  const partnerConfig = keyConfigs.filter((r: Types.ConfigurationRow) =>
                          isSelectedPartner(r.data.partner_code, partnerCode))
  return partnerConfig.length > 0 ? partnerConfig[0] :
           keyConfigs.filter((r: Types.ConfigurationRow) => isEmpty(r.data.partner_code))[0]
}

export const findConfigWithDefault =
  (key: string, partnerCode: string, configs: Types.ConfigurationRow[]): Types.ConfigurationRow => {
  const keyConfigs = configs.filter((r: Types.ConfigurationRow) => r.data.key === key)
  const partnerConfig = keyConfigs.filter((r: Types.ConfigurationRow) =>
                        isSelectedPartner(r.data.partner_code, partnerCode))
  return partnerConfig.length > 0 ? partnerConfig[0] :
           keyConfigs.filter((r: Types.ConfigurationRow) => isEmpty(r.data.partner_code))[0]
}

export const payloadDataToState =
  (data: Types.PayloadData[], keys: string[], prefixes: string[] = []): Types.CommunityConfigurationState => {
  const filtered: Types.PayloadData[] = data.filter((d: Types.PayloadData) => {
    return keys.includes(d.key) || !isEmpty(prefixes.filter((p: string) => d.key.startsWith(p)))
  })
  const transformed: any[] = filtered.map((d: Types.PayloadData) => (
    [
      d.id,
      {
        data: {
          ...d,
          isDefault: d.source === 'default',
          isEditing: false,
          is_active: true,
        },
        editing: {
          isEditing: false,
          isSynthecticRow: false,
          isUpdating: false,
        },
      },
    ]))
  return fromPairs(transformed)
}

export const updateState = (state: Types.CommunityConfigurationState, update: Types.UpdateStateAction) => {
  return {
    ...state,
      [update.rowId]: {
        ...state[update.rowId],
        ...{
          data: {
            ...state[update.rowId].data,
            ...{[update.property]: update.value},
            isEditing: true,
            is_active: isNil(update.isActive) ? true : update.isActive,
          },
          editing: {
            ...state[update.rowId].editing,
            isEditing: true,
          },
        },
      },
  }
}

export const addState = (state: Types.CommunityConfigurationState, action: Types.UpdateStateAction) => {
  const id = uuid()
  return {
    ...state,
    [id]: {
      ...{
        data: {
          created: moment.utc().format('ddd, DD MMM YYYY HH:mm:ss z'),
          id,
          isEditing: true,
          is_active: true,
          key: action.name,
          partner_code: action.partnerCode,
          updated: moment.utc().format('ddd, DD MMM YYYY HH:mm:ss z'),
          value: action.value,
        },
        editing: {
          ...{
            isEditing: true,
            isSyntheticRow: true,
          },
        },
      },
    },
  }
}

export const deleteState = (state: Types.CommunityConfigurationState, action: Types.UpdateStateAction) => {
  return {
    ...state,
    [action.rowId]: {
      ...state[action.rowId],
      data: {
        ...state[action.rowId].data,
        isEditing: true,
        is_active: false,
      },
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/newsbrief/utils.ts